/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
// @mui
import { Box, MenuItem, Pagination, Select, Stack, Typography } from '@mui/material';
import EmptyContent from '../../components/EmptyContent';
import { SkeletonCommentItem } from '../../components/skeleton/SkeletonItem';
import useLocales from '../../hooks/useLocales';
import { getComments, setCommentSearch } from '../../redux/slices/blog/blog.comment';
import { useDispatch, useSelector } from '../../redux/store';
import { CommentItemWrapper } from './CommentItem';

// ----------------------------------------------------------------------
export default function CommentList() {
  const dispatch = useDispatch();
  const { translate } = useLocales();

  const { comments, totalPages, isLoading, search, numberOfElements } = useSelector((state) => state.blogComment);
  const [sortBy, setSortBy] = useState("0");

  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(getComments());
    }, 500);
    return () => clearTimeout(timeout);
  }, [search]);

  const handleChangePage = (_, value) => {
    dispatch(setCommentSearch({ ...search, page: value - 1 }));
  };

  const handleChangeSort = (event) => {
    let value = event.target.value;

    let orders = [{ order: "desc", property: 'createdAt' }];

    if (value === "0") orders = [{ order: "desc", property: 'createdAt' }];
    else if (value === "1") orders = [{ order: "asc", property: 'createdAt' }];
    else orders = [{ order: "desc", property: 'likeNo' }];

    dispatch(setCommentSearch({ ...search, page: 0, orders }));
    setSortBy(value);
  };

  return (
    <Stack my={1} spacing={2}>
      <Box>
        <Typography variant='caption'>{translate("label.sortBy")}: </Typography>
        <Select variant='standard' value={sortBy} size='small' sx={{ fontSize: 12, fontWeight: 'bold', ml: 1, pt: 1 }} disableUnderline
          onChange={handleChangeSort} >
          <MenuItem value={"0"} sx={{ fontSize: 12 }}>{translate("label.sortByNew")}</MenuItem>
          <MenuItem value={"1"} sx={{ fontSize: 12 }} >{translate("label.sortByOld")}</MenuItem>
          <MenuItem value={"2"} sx={{ fontSize: 12 }}>{translate("label.sortByLike")}</MenuItem>
        </Select>
      </Box>
      <Stack spacing={2}>
        {comments.map((comment) => (
          <CommentItemWrapper comment={comment} key={comment.id} />
        ))}
        {isLoading ? <SkeletonCommentItem /> :
          numberOfElements == 0 && <EmptyContent title={" "} description={translate("hackerthon.exercise.noComment")} />}
      </Stack>

      {numberOfElements > 0 && <Stack alignItems={"center"} my={1.5}>
        <Pagination count={totalPages} variant='text' page={search.page + 1} onChange={handleChangePage} />
      </Stack>}
    </Stack>
  );
}
